module.exports = __webpack_public_path__ + "static/media/placeholder.97a8c7ee.png";